import { render, staticRenderFns } from "./HighlightsPreview.vue?vue&type=template&id=27946f90&scoped=true&"
import script from "./HighlightsPreview.vue?vue&type=script&lang=js&"
export * from "./HighlightsPreview.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsPreview.vue?vue&type=style&index=0&id=27946f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27946f90",
  null
  
)

export default component.exports